import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import './LegalPage.scss';

const LegalPage = ({ product, title, children }) => (
    <div className="legal-page">
        <header className="legal-header">
            <Container maxWidth="md">
                <Link to="/" className="legal-back">&larr; Back to Home</Link>
                <Typography variant="overline" className="legal-product">
                    {product}
                </Typography>
                <Typography variant="h4" className="legal-title">
                    {title}
                </Typography>
            </Container>
        </header>
        <Container maxWidth="md">
            <Box className="legal-content">
                {children}
            </Box>
        </Container>
    </div>
);

export default LegalPage;
